//用于管理home模块的小仓库
import { defineStore } from 'pinia'  //引入创建pinia的方法

import { reqGetBannerList, reqGetProductShow, getHomeSliderList_url, getHomePipelineInnovationList_url, getHomeCorporateAdvantageList_url } from '@/api'  //引入发送请求获取数据的方法

export const useHomeStore = defineStore('home', {
  //state：仓库存储数据的地方
  state: () => ({
    bannerList: [], //轮播图数据
    productShow: [],//产品展示数据

    homeBannerList: [], //轮播图数据
    InnovationList: [],//管线创新
    porateAdvantageList: [],//获取首页企业优势列表
  }),

  //action：处理action，可以书写自己的业务逻辑,可以直接修改state
  actions: {
    //首页轮播图数据
    async getBannerList () {
      let result = await reqGetBannerList()
      if (result.code == 200) {
        this.bannerList = result.data
      }
    },
    //首页产品展示数据
    async getProductShow () {
      let result = await reqGetProductShow()
      if (result.code == 200) {
        // console.log('result=', result)
        this.productShow = result.data
      }
    },
    //获取后台轮播图
    async getHomeSliderList () {
      let result = await getHomeSliderList_url()
      if (result.code == 200) {
        // console.log('homeBannerList=', result.data)
        this.homeBannerList = result.data
      }
    },
    //获取后台管线创新
    async getHomePipelineInnovationList () {
      let result = await getHomePipelineInnovationList_url()
      if (result.code == 200) {
        // console.log('InnovationList=', result.data)
        this.InnovationList = result.data
      }
    },

    //获取企业优势列表
    async getHomeCorporateAdvantageList () {
      let result = await getHomeCorporateAdvantageList_url()
      if (result.code == 200) {
        // console.log('porateAdvantageList=', result.data)
        this.porateAdvantageList = result.data
      }
    },

  },

  //getters：可以理解为计算属性，用于简化仓库属性。让组件获取仓库数据更便捷
  getters: {

  }
})